import { CompositeLayerProps } from '@Map/layers/types';
import type VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';

import HighlightBackgroundLayer from './HighlightBackgroundLayer';
import type { CompositeLike } from './LayerBase';

export default class HighlightForegroundLayer extends HighlightBackgroundLayer {
	constructor(
		layerInfo: CompositeLayerProps,
		vectorTileLayer?: VectorTileLayer,
		composite?: CompositeLike,
	) {
		super(layerInfo, vectorTileLayer, {
			zIndexesPerType: { base: 2002, line: 2002, symbol: 2002 },
			idPostfix: '-highlight-foreground',
			highlightForeground: true,
			composite,
		});
	}
}
